(function () {
// PAGES
function $6074568c9c4450be$export$2e2bcd8739ae039() {
    const attr = "[js-password]";
    const divs = document.querySelectorAll(`.show-password${attr}`);
    if (!divs.length) return;
    function handleEvent(div) {
        return function(event) {
            let input = div.querySelector("[js-input-password]");
            let item = event.currentTarget;
            input.type = input.type == "text" ? "password" : "text";
            if (input.type == "text") item.classList.add("mostra");
            else item.classList.remove("mostra");
        };
    }
    divs.forEach((div)=>{
        const buttonPass = div.querySelector(".password");
        buttonPass.addEventListener("click", handleEvent(div));
    });
}


function $2914c72b259257f0$export$2e2bcd8739ae039() {
    const allFormsErrors = document.querySelectorAll("[id^='form-errors']");
    allFormsErrors.forEach((formErrors)=>showErrors(formErrors));
    function showErrors(formErrors) {
        const errorsText = formErrors.textContent;
        const errors = JSON.parse(errorsText).__all__;
        errors && errors.forEach((error)=>error ? GLOBAL.showToastify(error) : "");
    }
}


const $9eeb9cdeb2ad1575$var$SwiperStage = ()=>{
    // Função construtura do Swiper
    function construct_swiper(allStages, classSwiper) {
        if (allStages.length > 0) {
            const ContainerSwiper = document.querySelector(`.${classSwiper} .swiper-wrapper`);
            allStages.forEach((stage)=>{
                // console.log(stage);
                ContainerSwiper.innerHTML += `<div class="swiper-slide">${stage.outerHTML}</div>`;
            });
        }
    }
    //Função inicializadora do Swiper
    function swiper_init(classSwiper) {
        const swiper = new Swiper(`.${classSwiper}`, {
            slidesPerView: 1.225,
            spaceBetween: 30,
            autoplay: {
                delay: 4000
            },
            breakpoints: {
                500: {
                    slidesPerView: 1.225
                },
                640: {
                    slidesPerView: 1.6
                },
                720: {
                    slidesPerView: 1.8
                },
                1200: {
                    slidesPerView: 2.5
                }
            }
        });
    }
    function main() {
        /**  Variáveis Constantes */ const classSwiper = "swiper-stages";
        const classBoxItensStages = "box-stages";
        const classItemStage = "card-stage";
        const Stages = document.querySelectorAll(`.${classBoxItensStages} .${classItemStage}`);
        if (Stages) {
            construct_swiper(Stages, classSwiper);
            swiper_init(classSwiper);
        }
    }
    main();
};
var $9eeb9cdeb2ad1575$export$2e2bcd8739ae039 = $9eeb9cdeb2ad1575$var$SwiperStage;


const $d9d9bc1a65488108$var$Button_Hamburge = ()=>{
    function main() {
        const idMenuPrincipal = "bt-mobile";
        const classItensMenus = "menu-principal";
        const MenuPrincipal = document.querySelector(`#${idMenuPrincipal}`);
        const ItensMenus = document.querySelector(`.${classItensMenus}`);
        if (MenuPrincipal) MenuPrincipal.addEventListener("click", (e)=>{
            if (e.target.classList.contains("active")) {
                e.target.classList.remove("active");
                ItensMenus.classList.remove("active");
            } else {
                e.target.classList.add("active");
                ItensMenus.classList.add("active");
            }
        });
        const OptionMenu = document.querySelectorAll(`.${classItensMenus} li a`);
        if (OptionMenu) OptionMenu.forEach((item_nav)=>{
            item_nav.addEventListener("click", ()=>{
                MenuPrincipal.classList.remove("active");
                ItensMenus.classList.remove("active");
            });
        });
    }
    main();
};
var $d9d9bc1a65488108$export$2e2bcd8739ae039 = $d9d9bc1a65488108$var$Button_Hamburge;


const $02a3aa6b8c0340b6$var$Nav = ()=>{
    function main() {
        const idNavPrincipal = "nav-principal";
        const NavPrincipal = document.querySelector(`#${idNavPrincipal}`);
        document.addEventListener("scroll", (e)=>{
            const ScrollTop = e.target.scrollingElement.scrollTop;
            if (ScrollTop > 80) NavPrincipal.classList.add("active");
            else NavPrincipal.classList.remove("active");
        });
    }
    main();
};
var $02a3aa6b8c0340b6$export$2e2bcd8739ae039 = $02a3aa6b8c0340b6$var$Nav;


function $630ee6e4137a1b6c$export$2e2bcd8739ae039() {
    const contatoFormSubmit = document.querySelector("#enter-in-contact");
    contatoFormSubmit && contatoFormSubmit.addEventListener("submit", function(event) {
        event.preventDefault();
        disabledBtn();
        const form_data = {
            nome: document.querySelector("#enter-in-contact input[name=form_Nome]").value,
            email: document.querySelector("#enter-in-contact input[name=form_E-mail]").value,
            mensagem: document.querySelector("#enter-in-contact textarea[name=form_Mensagem]").value
        };
        console.log(form_data);
        const url = "/fale-conosco/";
        axios.post(url, form_data).then((response)=>showMessage(response)).catch((response)=>showMessage(response));
    });
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message;
        GLOBAL.showToastify(message);
        contatoFormSubmit.reset();
        setTimeout(enabledBtn, 1000);
    }
    const btnSubmit = document.querySelector("#enter-in-contact .bt-enter-in-contact[type=submit]");
    function disabledBtn() {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
    }
    function enabledBtn() {
        btnSubmit.disabled = false;
        btnSubmit.classList.remove("disabled");
    }
}


const $ad253d60d7afe5ec$var$pageHome = document.querySelector("#page__home");
const $ad253d60d7afe5ec$var$pageCompliance = document.querySelector("#page__compliance");
const $ad253d60d7afe5ec$var$pageTrabalheConosco = document.querySelector("#page__trabalhe_conosco");
(0, $6074568c9c4450be$export$2e2bcd8739ae039)();
(0, $2914c72b259257f0$export$2e2bcd8739ae039)();
// ★ Pages Scopo
if ($ad253d60d7afe5ec$var$pageHome) {
    document.body.classList.add("page__home");
    (0, $d9d9bc1a65488108$export$2e2bcd8739ae039)();
    (0, $9eeb9cdeb2ad1575$export$2e2bcd8739ae039)();
    (0, $02a3aa6b8c0340b6$export$2e2bcd8739ae039)();
    (0, $630ee6e4137a1b6c$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageCompliance) {
    document.body.classList.add("page__compliance");
    (0, $d9d9bc1a65488108$export$2e2bcd8739ae039)();
    (0, $02a3aa6b8c0340b6$export$2e2bcd8739ae039)();
    (0, $630ee6e4137a1b6c$export$2e2bcd8739ae039)();
} else if ($ad253d60d7afe5ec$var$pageTrabalheConosco) {
    document.body.classList.add("page__trabalhe_conosco");
    (0, $d9d9bc1a65488108$export$2e2bcd8739ae039)();
    (0, $02a3aa6b8c0340b6$export$2e2bcd8739ae039)();
}
document.addEventListener("DOMContentLoaded", ()=>document.body.classList.add("dcl"));

})();
//# sourceMappingURL=main.js.map
